import { ReactNode } from "react";

const OverviewCard = ({
  title,
  description,
}: {
  title: ReactNode;
  description: ReactNode;
}) => {
  return (
    <div className="font-inter border border-card-border bg-card-background backdrop-blur-[10px] px-4 md:px-6 py-6 md:py-8 flex flex-col gap-[14px] items-start">
      <h3 className="text-2xl text-white font-semibold leading-[26px]">
        {title}
      </h3>
      <p className="text-subtext text-base">{description}</p>
    </div>
  );
};

export default OverviewCard;
